exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DateRangeSlider__slider__2sARt1 {\n  width: 100%;\n  height: 100%;\n  background: #245da7;\n  opacity: 0.6;\n  cursor: all-scroll;\n  position: relative;\n}\n.DateRangeSlider__handle__2oBfNz {\n  display: block;\n  cursor: ew-resize;\n  position: absolute;\n  top: 50%;\n  height: 20px;\n  width: 5px;\n  background: #aaa;\n  border: solid 1px #333;\n  border-radius: 3px;\n}\n.DateRangeSlider__e__2rby7H {\n  right: 0;\n  -webkit-transform: translate(50%, -50%);\n          transform: translate(50%, -50%);\n}\n.DateRangeSlider__w__1XpmHX {\n  left: 0;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);

// exports
exports.locals = {
	"slider": "DateRangeSlider__slider__2sARt1",
	"handle": "DateRangeSlider__handle__2oBfNz",
	"e": "DateRangeSlider__e__2rby7H",
	"w": "DateRangeSlider__w__1XpmHX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/DateRangeSlider.styl
// module id = 3612
// module chunks = 39